import { render, staticRenderFns } from "./Commit.vue?vue&type=template&id=48475c03&scoped=true&"
import script from "./Commit.vue?vue&type=script&lang=js&"
export * from "./Commit.vue?vue&type=script&lang=js&"
import style0 from "./Commit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Commit.vue?vue&type=style&index=1&id=48475c03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48475c03",
  null
  
)

export default component.exports